export enum RealTimeCountStatusEnum {
    pending,
    computing,
    completed,
    failed,
    cancelled,
    expired
}
